// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orderOperationDetail_modal__bH5yb {
  max-width: 63vw;
  max-height: 80vh;
  height: max-content;
  position: relative; }
  .orderOperationDetail_modal__bH5yb img,
  .orderOperationDetail_modal__bH5yb video {
    max-width: 63vw;
    max-height: calc(80vh - 170px); }

.orderOperationDetail_header__NYm73 {
  display: flex;
  justify-content: space-between; }
  .orderOperationDetail_header_title__1HrFr {
    font-weight: 600;
    font-size: 12px;
    line-height: 150%;
    color: var(--HightEmphasis);
    margin-bottom: 10px; }

.orderOperationDetail_infoBlock__pFHBW {
  padding: 10px; }

.orderOperationDetail_wrapper__A0jT7 {
  display: flex;
  flex-direction: column;
  gap: 5px; }

.orderOperationDetail_subtitle__IXusk {
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  color: var(--MediumEmphasis); }
  .orderOperationDetail_subtitle_value__3S8b- {
    font-weight: 500;
    color: var(--HightEmphasis); }
    .orderOperationDetail_subtitle_value_clipboard__iANSp {
      font-weight: 500;
      color: var(--Orange);
      cursor: pointer; }

.orderOperationDetail_cross__FGSin {
  position: absolute;
  top: 26px;
  right: 26px;
  color: var(--HightEmphasis);
  cursor: pointer;
  z-index: 1; }
  .orderOperationDetail_cross__FGSin:hover {
    color: var(--MediumEmphasis); }

.orderOperationDetail_download__jUqbW {
  position: absolute;
  width: 24px;
  height: 24px;
  padding: 4px;
  bottom: 14px;
  right: 14px;
  color: var(--MediumEmphasis);
  cursor: pointer; }
  .orderOperationDetail_download__jUqbW:hover {
    color: var(--HightEmphasis); }

.orderOperationDetail_time__Kzehz {
  position: absolute;
  left: calc(50% - 100px);
  bottom: 170px;
  color: white;
  display: flex;
  align-items: center;
  gap: 30px;
  border-radius: 31px;
  background: rgba(0, 0, 0, 0.5);
  padding: 5px 15px; }
  .orderOperationDetail_time__Kzehz .orderOperationDetail_svg__oKcuj {
    opacity: 0.7;
    cursor: pointer;
    transition: all 0.4s; }
    .orderOperationDetail_time__Kzehz .orderOperationDetail_svg__oKcuj:hover {
      opacity: 1; }
  .orderOperationDetail_time__container__WXgVI {
    display: flex;
    flex-direction: column;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-family: Inter;
    line-height: 120%;
    letter-spacing: 0.1px; }
`, "",{"version":3,"sources":["webpack://./src/components/orderOperationDetail/orderOperationDetail.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAA;EAJpB;;IAOI,eAAe;IACf,8BAA8B,EAAA;;AAIlC;EACE,aAAa;EACb,8BAA8B,EAAA;EAC9B;ICaA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDbf,2BAA2B;IAC3B,mBAAmB,EAAA;;AAIvB;EACE,aAAa,EAAA;;AAEf;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ,EAAA;;AAGV;ECiCE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDjCjB,4BAA4B,EAAA;EAC5B;IACE,gBAAgB;IAChB,2BAA2B,EAAA;IAC3B;MACE,gBAAgB;MAChB,oBAAoB;MACpB,eAAe,EAAA;;AAKrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,UAAU,EAAA;EANZ;IAQI,4BAA4B,EAAA;;AAIhC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,eAAe,EAAA;EARjB;IAUI,2BAA2B,EAAA;;AAI/B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB,EAAA;EAVnB;IAYI,YAAY;IACZ,eAAe;IACf,oBAAoB,EAAA;IAdxB;MAgBM,UAAU,EAAA;EAGd;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.modal {\n  max-width: 63vw;\n  max-height: 80vh;\n  height: max-content;\n  position: relative;\n  img,\n  video {\n    max-width: 63vw;\n    max-height: calc(80vh - 170px);\n  }\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  &_title {\n    @include h6;\n    color: var(--HightEmphasis);\n    margin-bottom: 10px;\n  }\n}\n\n.infoBlock {\n  padding: 10px;\n}\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.subtitle {\n  @include caption;\n  color: var(--MediumEmphasis);\n  &_value {\n    font-weight: 500;\n    color: var(--HightEmphasis);\n    &_clipboard {\n      font-weight: 500;\n      color: var(--Orange);\n      cursor: pointer;\n    }\n  }\n}\n\n.cross {\n  position: absolute;\n  top: 26px;\n  right: 26px;\n  color: var(--HightEmphasis);\n  cursor: pointer;\n  z-index: 1;\n  &:hover {\n    color: var(--MediumEmphasis);\n  }\n}\n\n.download {\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  padding: 4px;\n  bottom: 14px;\n  right: 14px;\n  color: var(--MediumEmphasis);\n  cursor: pointer;\n  &:hover {\n    color: var(--HightEmphasis);\n  }\n}\n\n.time {\n  position: absolute;\n  left: calc(50% - 100px);\n  bottom: 170px;\n  color: white;\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  border-radius: 31px;\n  background: rgba(0, 0, 0, 0.5);\n  padding: 5px 15px;\n  .svg{\n    opacity: 0.7;\n    cursor: pointer;\n    transition: all 0.4s;\n    &:hover{\n      opacity: 1;\n    }\n  }\n  &__container {\n    display: flex;\n    flex-direction: column;\n    color: #fff;\n    text-align: center;\n    font-size: 14px;\n    font-family: Inter;\n    line-height: 120%;\n    letter-spacing: 0.1px;\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `orderOperationDetail_modal__bH5yb`,
	"header": `orderOperationDetail_header__NYm73`,
	"header_title": `orderOperationDetail_header_title__1HrFr`,
	"infoBlock": `orderOperationDetail_infoBlock__pFHBW`,
	"wrapper": `orderOperationDetail_wrapper__A0jT7`,
	"subtitle": `orderOperationDetail_subtitle__IXusk`,
	"subtitle_value": `orderOperationDetail_subtitle_value__3S8b-`,
	"subtitle_value_clipboard": `orderOperationDetail_subtitle_value_clipboard__iANSp`,
	"cross": `orderOperationDetail_cross__FGSin`,
	"download": `orderOperationDetail_download__jUqbW`,
	"time": `orderOperationDetail_time__Kzehz`,
	"svg": `orderOperationDetail_svg__oKcuj`,
	"time__container": `orderOperationDetail_time__container__WXgVI`
};
export default ___CSS_LOADER_EXPORT___;
